export default {
  title: 'Löydä jotain mistä pidät!',
  description: 'Tilauksesi näkyvät täällä.',
  buttons: {
    order_now: 'Tilaa nyt',
  },
};
